import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {

	constructor(private sanitizer: DomSanitizer) {}

	transform(value: any): any {
		if (!value) return '';

		// Convert markdown to HTML
		let html = value
			.replace(/^### (.*$)/gim, '<h3>$1</h3>')
			.replace(/^## (.*$)/gim, '<h2>$1</h2>')
			.replace(/^# (.*$)/gim, '<h1>$1</h1>')
			.replace(/^\> (.*$)/gim, '<blockquote>$1</blockquote>')
			.replace(/\*\*(.*)\*\*/gim, '<b>$1</b>')
			.replace(/\*(.*)\*/gim, '<i>$1</i>')
			.replace(/!\[(.*?)\]\((.*?)\)/gim, "<img alt='$1' src='$2' />")
			.replace(/\[(.*?)\]\((.*?)\)/gim, "<a href='$2'>$1</a>")
			.replace(/^(\d+\.\s)/gim, '<b>$1</b>')
			.replace(/^\s*-\s/gm, ' - ')
			.replace(/\n/g, '<br>');

		return this.sanitizer.bypassSecurityTrustHtml(html);
	}
}
